/**
 * Bandeau d'espace (lot 1d, 2026-10-28) : visible seulement si l'utilisateur est membre d'au moins
 * un autre espace ; montre l'espace courant et permet d'en changer (rechargement complet).
 */
import { useTranslation } from 'react-i18next';
import { Users } from 'lucide-react';
import { useWorkspace, useWorkspaceBootstrap } from '@/hooks/useWorkspace';

export function WorkspaceBanner() {
  const { t } = useTranslation();
  const { user, memberships, current, currentId, select } = useWorkspace();
  useWorkspaceBootstrap();
  if (!user || memberships.length === 0) return null;
  const label = current ? current.owner_name || current.owner_email : t('workspace.mine');
  return (
    <div className="sticky top-0 z-20 flex items-center justify-between gap-3 border-b border-ink/[0.06] bg-white/85 px-4 py-2 text-[13px] backdrop-blur sm:px-6" role="region" aria-label={t('workspace.banner')} data-workspace={currentId ?? 'mine'}>
      <span className="inline-flex min-w-0 items-center gap-2">
        <Users size={14} className="shrink-0 text-violet-600" />
        <span className="text-ink/60">{t('workspace.banner')}</span>
        <strong className="truncate">{label}</strong>
        {current && <span className="rounded-full bg-violet-500/10 px-2 py-0.5 text-[11px] font-700 uppercase tracking-[0.08em] text-violet-700">{t(`automations.team.roles.${current.role}`)}</span>}
      </span>
      <select value={currentId ?? ''} onChange={(e) => select(e.target.value || null)} aria-label={t('workspace.select')} className="max-w-[46%] rounded-lg border border-ink/10 bg-white px-2 py-1 text-[12px]">
        <option value="">{t('workspace.mine')}</option>
        {memberships.map((m) => <option key={m.id} value={m.owner_user_id}>{m.owner_name || m.owner_email}</option>)}
      </select>
    </div>
  );
}
